import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { ScimTokenCard, SsoConfigCard } from "@/modules/admin";

export default function AdminSsoPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.sso.pageTitle")}
      description={t("admin.sso.pageDescription")}
    >
      <PermissionGate
        perm="sso.read"
        fallback={
          <p className="card text-sm text-nb-text-2">{t("admin.noPermission")}</p>
        }
      >
        <SsoConfigCard />
        <ScimTokenCard />
      </PermissionGate>
    </AppLayout>
  );
}
